import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

import { DefaultProps } from "@/types/react";
import { CopyText, CopyTextProps } from "../CopyText";
import { A11yText } from "../A11yText";

import styles from "./RadioButton.scss";

type RadioButtonLegendCopyTextProps = Omit<CopyTextProps<"legend">, "tag">;
type RadioButtonLegendBaseProps = {
  a11y?: boolean;
  customClass?: string;
  variants?: RadioButtonLegendCopyTextProps["variants"];
};
export type RadioButtonLegendProps = RadioButtonLegendBaseProps &
  Omit<RadioButtonLegendCopyTextProps, "variants">;

const defaultProps: DefaultProps<RadioButtonLegendBaseProps> = {
  customClass: undefined,
  variants: CopyText.Variant.additional,
  a11y: false,
} as const;

export const RadioButtonLegend = ({
  variants = defaultProps.variants,
  a11y = defaultProps.a11y,
  children,
  customClass,
  ...restProps
}: RadioButtonLegendProps): JSX.Element => {
  return a11y ? (
    <A11yText tag="legend">{children}</A11yText>
  ) : (
    <CopyText
      tag="legend"
      customClass={cn(styles.legend, customClass)}
      variants={variants}
      {...restProps}
    >
      {children}
    </CopyText>
  );
};

RadioButtonLegend.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  customClass: PropTypes.string,
  variants: PropTypes.string,
  a11y: PropTypes.bool,
};

RadioButtonLegend.defaultProps = defaultProps;

RadioButtonLegend.displayName = "RadioButton.Legend";

export default RadioButtonLegend;
